var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtmlBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43164 0H7.86553V2.40469H10.092V0H12.526V7.28199H10.0921V4.84355H7.86565V7.28199H5.43173L5.43164 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7267 2.41481H13.584V0H20.3045V2.41481H18.1607V7.28199H15.7268L15.7267 2.41481Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3711 0H23.9091L25.4701 2.55868L27.0296 0H29.5685V7.28199H27.1446V3.67263L25.4701 6.2618H25.4283L23.7525 3.67263V7.28199H21.3711V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7793 0H33.214V4.87499H36.6367V7.28199H30.7793V0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35334 49.6639L0.75 10.6133H41.25L36.6436 49.6578L20.9768 54.001L5.35334 49.6639ZM14.6627 28.2896L14.225 23.385H32.5522L32.981 18.5956H8.99085L10.2826 33.0789H26.8811L26.3253 39.2903L20.9836 40.7321L20.9798 40.7336L15.6459 39.2934L15.3049 35.4736H10.4971L11.1681 42.9938L20.9788 45.7172L30.8021 42.9935L31.9996 29.5757L32.1163 28.2896H14.6627Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlBlack);
export default __webpack_public_path__ + "static/media/html-black.ec19463570b68ae32e16dd6012b0eec9.svg";
export { ForwardRef as ReactComponent };